import cookie from 'cookie-cutter';
import { useEffect } from 'react';
import { connect } from 'react-redux';

import * as duckActions from './duck';

export const Logout = props => {
    const { isKiosk, originPath, logOut } = props;
    useEffect(() => {
        logOut().then(() => {
            if (isKiosk) {
                // allow each new run to reset language
                cookie.set('language', { expires: new Date(0) });
            }
            if (!process.env.STORYBOOK_ENV) {
                window.location.assign(originPath || '/');
            }
        });
    }, []);

    return (
        <div className="logout-container">
            <h1 style={{ marginTop: '2em' }}>Logging Out</h1>
        </div>
    );
};

export const mapStateToProps = (state, ownProps) => {
    const { isKiosk, originPath } = state.introduction;
    return Object.assign({}, { isKiosk, originPath }, ownProps);
};

export default connect(mapStateToProps, duckActions)(Logout);
